/* src/app/common/components/footer/footer.component.scss */
footer {
  background: var(--bg-more-light-pink);
  color: var(--color-black1);
  margin-bottom: -1px;
  border-color: var(--color-primary) !important;
}
@media (min-width: 576px) and (max-width: 767.98px) {
  footer {
    padding: 10px;
  }
  footer .w-25 {
    width: 100% !important;
  }
  footer .w-75 {
    width: 100% !important;
    justify-content: center !important;
  }
  footer .w-50 {
    width: 100% !important;
    margin-top: 10px;
  }
}
footer .footer-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}
footer ul li {
  list-style: none;
  margin-bottom: 16px;
  padding: 0 0px;
}
.footer-bottom {
  padding: 10px;
  color: var(--color-black1);
}
.footer-bottom .container {
  border-color: var(--footer-border-color) !important;
}
.footer-social {
  padding: 10px;
  color: var(--color-black1);
}
.footer-social .container {
  border-color: var(--footer-border-color) !important;
}
.footer-top .container p small {
  color: var(--color-black);
}
.copy-rights {
  max-width: 320px;
}
.copy-rights p small {
  font: 13px;
}
a {
  transition: all 0.25s;
}
a:hover {
  color: var(--bs-orange-theme);
}
@media screen and (max-width: 767px) {
  .footer-logo {
    margin: 0;
  }
  .footer-logo .copy-rights {
    margin: 0 auto;
  }
}
.footer-logo small,
.footer-logo span {
  font-size: 16px;
  font-family: "Noto Sans ExtraBold";
  color: var(--kendo-component-bg);
}
@media screen and (max-width: 767px) {
  .footer-logo small,
  .footer-logo span {
    font-size: 16px;
  }
}
.footer-logo small.fw-bold,
.footer-logo span.fw-bold {
  font-family: "Noto Sans Bold";
}
.social-icons {
  font-size: 16px;
  font-weight: 700;
  color: var(--tile-color);
}
.social-icons a {
  padding: 10px;
  border-radius: 8px;
  background-color: var(--text-pink);
}
footer ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
footer ul li a {
  margin: 0 0 15px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  color: var(--color-black1);
  transition: all 0.25s;
}
footer ul li a:hover {
  color: var(--bs-orange-theme) !important;
}
@media screen and (max-width: 1023px) {
  footer ul li a {
    font-size: 14px;
  }
}
@media screen and (max-width: 767px) {
  footer ul li a {
    font-size: 12px;
  }
}
footer ul li:last-child {
  margin-bottom: 0;
}
.copy-right {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid var(--text-pink);
}
@media screen and (max-width: 1023px) {
  .copy-right {
    margin-top: 20px;
    padding-top: 20px;
  }
}
@media screen and (max-width: 767px) {
  .copy-right {
    margin-top: 15px;
    padding-top: 15px;
  }
}
.copy-right p {
  color: var(--color-black1);
  font-size: 14px;
  font-weight: 500;
}
.copy-right p .border-left {
  border-left: 1px solid var(--color-black1);
}
@media screen and (max-width: 1023px) {
  .copy-right p {
    font-size: 14px;
  }
}
@media screen and (max-width: 767px) {
  .copy-right p {
    font-size: 12px;
  }
}
/*# sourceMappingURL=footer.component-BVDAZXHJ.css.map */
